<template>
  <div>
    <list row-key="id" ref="list" unit="订单" :page="page" :query-params="params" :show-checkbox="showCheckbox"
      :show-query="showQuery" :get-data-func="getDataFunc" :after-get-data-func="setStyle" :toolbar-left="16"
      :toolbar-right="8" custom-class="merge-table">
      <div slot="toolbar">
        <div class="toolbar">
          <el-select v-model="quickCheck" @change="onQuickCheck" style="width: 100px;" clearable>
            <el-option label="快捷勾选" :value="0"></el-option>
            <el-option label="全部勾选" :value="1"></el-option>
            <el-option label="取消勾选" :value="2"></el-option>
          </el-select>
          <el-select v-model="temp" style="width: 300px;margin: 0 10px;">
            <el-option v-for="(i, k) in waybillList" :key="k" :label="i.logisticsCompany + '，剩余单数：' + i.quantity"
              :value="i.code"></el-option>
          </el-select>
          <el-button type="primary" @click="openPrint()">打印快递单</el-button>
          <el-button type="primary" @click="openPrintWithSend()">一键发货</el-button>
          <el-dropdown @command="moreAction" style="margin: 0 10px;">
            <el-button type="primary">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batchEditRemark">批量修改备注</el-dropdown-item>
              <el-dropdown-item command="batchRecycleNumber">批量回收单号</el-dropdown-item>
              <el-dropdown-item command="batchLock">批量锁定</el-dropdown-item>
              <el-dropdown-item command="batchUnlock">批量解锁</el-dropdown-item>
              <el-dropdown-item command="batchConsolidateOrders">批量合并订单</el-dropdown-item>
              <el-dropdown-item command="exportOrders">订单导出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="openSetting">设置</el-button>
          <div class="fullscreen-btn">
            <svg-icon v-if="fullscreen" iconClass="cancelfullscreen" @click="setScreen" />
            <svg-icon v-else iconClass="fullscreen" @click="setScreen" />
          </div>
        </div>
        <div class="toolbar">
          <div class="toolbar-left">
            <span>共查到</span>
            <span class="number">{{ totalOrder }}</span>
            <span>个订单，共</span>
            <span class="number">{{ totalParcel }}</span>
            <span>个包裹</span>
          </div>
          <div class="toolbar-right">
            <div style="display: flex;align-items: center;margin-right: 10px;">
              <div style="font-size: 14px;color: #606266;">订单排序：</div>
              <el-select v-model="snField" style="width: 150px">
                <el-option label="成团时间" value="成团时间"></el-option>
                <el-option label="剩余发货时间" value="剩余发货时间"></el-option>
                <el-option label="商品名称和规格" value="商品名称和规格"></el-option>
                <el-option label="规格名称" value="规格名称"></el-option>
                <el-option label="发货时间" value="发货时间"></el-option>
                <el-option label="省份城市" value="省份城市"></el-option>
                <el-option label="付款时间" value="付款时间"></el-option>
                <el-option label="商品数量" value="商品数量"></el-option>
                <el-option label="商品金额" value="商品金额"></el-option>
                <el-option label="实付金额" value="实付金额"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="onSnUp">升序</el-button>
            <el-button type="primary" @click="onSnDown">降序</el-button>
          </div>
        </div>
      </div>
      <template slot="query">
        <el-form-item label="店铺名称" label-width="112px">
          <el-select v-model="mallId" placeholder="请选择">
            <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.mallId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品搜索" label-width="112px">
          <el-input v-model="params.商品搜索" placeholder="请输入商品名称/ID/编码/简称" clearable />
        </el-form-item>
        <el-form-item label="规格搜索" label-width="112px">
          <el-input v-model="params.规格搜索" placeholder="请输入规格名称/ID/编码/简称" clearable />
        </el-form-item>
        <el-form-item label="售后状态" label-width="112px">
          <el-select v-model="params.售后状态" placeholder="请选择" clearable>
            <el-option label="无售后或售后关闭" :value="0"></el-option>
            <el-option label="有售后" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注留言" label-width="112px">
          <el-select v-model="params.备注留言" placeholder="请选择" clearable>
            <el-option label="无商家备注" :value="0"></el-option>
            <el-option label="有商家备注" :value="1"></el-option>
            <el-option label="有买家备注" :value="2"></el-option>
            <el-option label="无买家备注" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-select v-model="params.fieldType" style="width: 100px;">
              <el-option label="智能搜索" value="智能搜索"></el-option>
              <el-option label="商品付款" value="商品付款"></el-option>
              <el-option label="订单号" value="订单号"></el-option>
              <el-option label="快递单号" value="快递单号"></el-option>
              <el-option label="商品价格" value="商品价格"></el-option>
              <el-option label="实付金额" value="实付金额"></el-option>
              <el-option label="收件人" value="收件人"></el-option>
              <el-option label="手机号" value="手机号"></el-option>
            </el-select>
          </div>
          <el-input v-model="params.fieldValue" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="退款状态" label-width="112px">
          <el-select v-model="params.退款状态" placeholder="请选择" clearable>
            <el-option label="有退款" :value="1"></el-option>
            <el-option label="无退款" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区选择" label-width="112px">
          <address-select v-model="params.地区选择" :placeholder="'请选择地区'" @change="onAddressSelect" />
        </el-form-item>
        <el-form-item label="旗帜选择" label-width="112px">
          <el-select v-model="params.旗帜选择" placeholder="请选择" clearable>
            <el-option label="红" value="flag-red">红<i class="el-icon-s-flag flag-red"></i></el-option>
            <el-option label="橙" value="flag-orange">橙<i class="el-icon-s-flag flag-orange"></i></el-option>
            <el-option label="黄" value="flag-yellow">黄<i class="el-icon-s-flag flag-yellow"></i></el-option>
            <el-option label="绿" value="flag-green">绿<i class="el-icon-s-flag flag-green"></i></el-option>
            <el-option label="蓝" value="flag-blue">蓝<i class="el-icon-s-flag flag-blue"></i></el-option>
            <el-option label="靛" value="flag-indigo">靛<i class="el-icon-s-flag flag-indigo"></i></el-option>
            <el-option label="紫" value="flag-purple">紫<i class="el-icon-s-flag flag-purple"></i></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递公司" label-width="112px">
          <el-select v-model="params.快递公司" placeholder="请选择" clearable>
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.logisticsCompany" :value="i.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间类型" label-width="112px">
          <div class="time-type">
            <el-select v-model="params.时间类型">
              <el-option label="成团时间" value="成团时间"></el-option>
              <el-option label="发货时间" value="发货时间"></el-option>
              <el-option label="剩余时间" value="剩余时间"></el-option>
            </el-select>
            <range-picker :date="[params.startDate, params.endDate]"
              @change="x => { params.startDate = x.Start; params.endDate = x.End; }" />
          </div>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="收件信息" min-width="280px">
          <div slot-scope="{row}" class="merge-item">
            <div>
              <!-- <template v-if="row.state == 0 && row.multiorder.length == 1 && row.same">
                <div class="badge badge-nomerge">待合</div>
              </template> -->
              <template v-if="row.multiorder.length > 1">
                <div class="badge badge-merge">合单{{ row.multiorder.length }}</div>
              </template>
              <template v-if="row.state != 0 && row.logistics.length > 0">
                <template v-if="row.logistics.length > 1 || row.logistics[0].noList.length > 1">
                  <div class="badge badge-multiple-pack">多包</div>
                </template>
              </template>
              <span>{{ row.receiverAddress.fullName }}
                <template v-if="dataMasking && row.receiverAddress.fullName != row.decryptData.fullName">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'fullName')" />
                </template>
              </span>
              <span>，<span v-html="row.receiverAddress.mobilePhone"></span>
                <template v-if="dataMasking && row.receiverAddress.mobilePhone != row.decryptData.mobilePhone">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'mobilePhone')" />
                </template>
              </span>
            </div>
            <div>
              <span>{{ row.address }}</span>
              <span>{{ row.receiverAddress.detailAddress }}
                <template v-if="dataMasking && row.receiverAddress.detailAddress != row.decryptData.detailAddress">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'detailAddress')" />
                </template>
              </span>
            </div>
          </div>
        </el-table-column>
        <el-table-column label="合计" min-width="130px">
          <div slot-scope="{row}" class="merge-item">
            <div>
              <span>总数量：</span>
              <span>{{ row.items.map(x => x.goodsCount).reduce((a, b) => { return a + b }) }}</span>
            </div>
            <div>
              <span>总价：</span>
              <span>{{ row.goodsPrice }}</span>
            </div>
            <div>
              <span>实收：</span>
              <span>{{ row.payAmount }}</span>
            </div>
          </div>
        </el-table-column>
        <el-table-column label="商品信息" min-width="500px">
          <template slot-scope="{row}">
            <div v-for="(order, key) in row.multiorder" :key="key" :id="'order_' + order.id" class="merge-item"
              style="padding: 0;">
              <div v-for="(i, k) in order.items" :key="k" class="merge-item goods-info"
                :class="{ 'merge': order.items.length > 1 }">
                <div class="item-image">
                  <el-image v-if="i.goodsImageUrl" :src="i.goodsImageUrl" fit="contain">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div class="item-info">
                  <div class="ellipsis" :title="i.goodsName">{{ i.goodsName }}</div>
                  <div style="color: #9d9d9d"><span>规格：</span><span>{{ i.goodsSpec }}</span></div>
                  <div style="color: #9d9d9d"><span>数量：</span><span>{{ i.goodsCount }}</span></div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单时间" min-width="240px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'time_' + order.id">
              <div><span>成团时间：</span><span>{{ order.Field4_2 }}</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="80px" align="center">
          <div slot-scope="{row}" class="merge-item">
            <span v-if="row.isLock">已锁定</span>
            <template v-else>
              <span v-if="row.isPrint">已打印</span>
              <span v-else>未打印</span>
            </template>
          </div>
        </el-table-column>
        <el-table-column label="备注/旗帜" min-width="280px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'remark_' + order.id">
              <div v-if="order.flag"><i class="el-icon-s-flag" :class="order.flag"></i></div>
              <div><span>买家备注：</span><span>{{ order.Field6_2 || "无" }}</span></div>
              <div><span>卖家备注：</span><span>{{ order.Field6_3 || "无" }}</span></div>
              <div><el-button type="text" @click="editRemark(order)">修改</el-button></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单编号/店铺名称" min-width="200px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'mall_' + order.id">
              <div>{{ order.orderNumber }}</div>
              <div>{{ order.mall.mallName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="物流状态" width="80px" align="center">
          <div slot-scope="{row}" class="merge-item">
            <span v-if="row.orderStatus == 1">待发货</span>
            <span v-if="row.orderStatus == 2">已发货待签收</span>
            <span v-if="row.orderStatus == 3">已签收</span>
          </div>
        </el-table-column>
        <el-table-column label="快递信息" min-width="200px">
          <div slot-scope="{row}" class="merge-item">
            <template v-if="row.logistics && row.logistics.length > 0">
              <!-- <div v-for="(i1, k1) in row.logistics" :key="k1">
                <div>{{ i1.name }}：</div>
                <div v-for="(i2, k2) in i1.noList" :key="k2">{{ i2 }}</div>
              </div> -->
              <div v-for="(i1, k1) in row.logistics" :key="k1">
                <div>{{ i1.waybillCode }}</div>
              </div>
              <div><el-button type="text" @click="onCopy(row)">复制</el-button></div>
            </template>
            <span v-else>- -</span>
          </div>
        </el-table-column>
        <el-table-column label="单号状态" min-width="100px">
          <div slot-scope="{row}" class="merge-item">
            <div>
              <span v-if="row.Field9 == 0">- -</span>
              <span v-if="row.Field9 == 1">取号失败</span>
              <span v-if="row.Field9 == 2">正常</span>
              <span v-if="row.Field9 == 3">已回收</span>
              <span v-if="row.Field9 == 4">部分回收</span>
            </div>
            <div><el-button type="text" @click="showRecycle(row)">查看详情</el-button></div>
          </div>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <print-dialog ref="printDialog" />
    <express-dialog ref="expressDialog" @close-saved="reload" />
    <remark-dialog ref="remarkDialog" @close-saved="reload" />
    <setting-dialog ref="settingDialog" @close-saved="reload" />
    <recycle-msg-dialog ref="recycleMsgDialog" @closed="reload" />
    <recycle-dialog ref="recycleDialog" />
  </div>
</template>
<script>
import listMixin from "../mixins/list"; //部分相同的逻辑使用代码混入
import printDialog from "./printDialog";
import expressDialog from "./expressDialog";
import "../styles/list.scss";

export default {
  mixins: [listMixin],
  components: {
    printDialog, expressDialog,
  },
  data() {
    return {
      params: {
        isShipped: true,
      },
      totalOrder: 0,
      totalParcel: 0,
    };
  },
  mounted() { },
  methods: {
    getDataFunc(params) {
      params = this.$commonJs.obj.removeNullKey({
        ...params,
        SnField: this.snField,
        SnType: this.snType,
        [this.params.fieldType]: this.params.fieldValue
      })
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].order.getOrders(params, this.mallId).then(res => {
          console.log("getDataFunc", params)
          this.totalOrder = res.count;
          this.totalParcel = res.count;
          // res.data = res.data.filter(x => x.receiverAddress.fullName != "");
          // if (this.quickSearch != 3) {
          //   res.data = res.data.filter(x => x.Field5 == this.quickSearch);
          // }
          res.data = res.data.map(x => {

            var is_same = false;
            // var is_same = res.data.some(w => w.id != x.id && (
            //   w.receiverAddress.fullName == x.receiverAddress.fullName &&
            //   w.receiverAddress.mobilePhone == x.receiverAddress.mobilePhone &&
            //   w.receiverAddress.province == x.receiverAddress.province &&
            //   w.receiverAddress.city == x.receiverAddress.city &&
            //   w.receiverAddress.district == x.receiverAddress.district
            // ))

            var state = 0;
            var logistics = [];
            var multiorder = [{ ...x }];

            // if (x.id == 2) state = 1;
            // if (x.id == 3) {
            //   state = 2;
            //   // 单快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100"] },
            //   ];
            // }
            // if (x.id == 4) {
            //   state = 3;
            //   // 一个单，多商品
            //   multiorder = [{ ...x, items: [...x.items, ...x.items] }];
            // }
            // if (x.id == 5) {
            //   // 合单
            //   multiorder = [{ ...x }, { ...x, id: 12 }];
            // }
            // if (x.id == 6) {
            //   // 多快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100"] },
            //     { name: "中通快递", noList: ["ZT8962139805105", "ZT8962139805105", "ZT8962139805105", "ZT8962139805105"] }
            //   ];
            //   // 合单，单商品与多商品
            //   multiorder = [
            //     { ...x, items: [...x.items, ...x.items] },
            //     { ...x, id: 22 },
            //     { ...x, id: 32, items: [...x.items, ...x.items, ...x.items] }
            //   ];
            // }
            // if (x.id == 7) {
            //   state = 2;
            //   // 单快递，单面单
            //   logistics = [
            //     { name: "中通快递", noList: ["ZT8962139805105"] }
            //   ];
            // }
            // if (x.id == 8) {
            //   state = 2;
            //   // 多快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100"] },
            //     { name: "中通快递", noList: ["ZT8962139805105"] }
            //   ];
            // }
            return {
              ...x,
              address: x.receiverAddress.province + x.receiverAddress.city + x.receiverAddress.district,
              state: state,
              multiorder: multiorder, // 合单
              logistics: logistics, // 快递信息
              same: is_same,
              decryptData: {
                fullName: "",
                mobilePhone: "",
                detailAddress: "",
              }
            }
          })
          resolve(res)
        }).catch(err => {
          resolve({ Code: 1, data: [] })
        })
      })
    },
    openPrint(data = null) {
      console.log("open", data)
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
      }
      this.$refs.printDialog.open().then(that => {
        that.setData({ state: rows[0].Field5, autoSend: false, rows: rows });
      });
    },
    openPrintWithSend(data = null) {
      this.$message.warning("已发货，无法操作");
    },
    onUpdateExpress(row) {
      console.log("onUpdateExpress", row);
      this.$refs.expressDialog.openEdit(row)
    },
  },
};
</script>
<style lang="scss"></style>